export default __webpack_public_path__ + "static/media/e-ks-picturemark-d.3e6a1a3a.svg";